import React from 'react';

/** Horizontal section tabs across the top of the help drawer. */
export default function HelpNav({ sections, activeSection, onSectionChange }) {
  return (
    <div className="help-nav" role="tablist">
      {sections.map((section) => {
        const isActive = activeSection === section.id;
        return (
          <button
            key={section.id}
            type="button"
            className={`help-nav__tab${isActive ? ' is-active' : ''}`}
            onClick={() => onSectionChange(section.id)}
            role="tab"
            aria-selected={isActive}
            data-testid={`help-tab-${section.id}`}
          >
            <i className={section.icon} aria-hidden="true" />
            <span>{section.title}</span>
          </button>
        );
      })}
    </div>
  );
}
